export const reportTypeEnum = {
    'Note': 'note',
    'Phone Call': 'phone',
    'Email': 'email',
    'Contact Form': 'contact form',
    'Walk in': "walk-in"
}